// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_FichaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /rede/ficha — grava a ficha inteira de uma unidade e a lista de sócios (Full). */
import type { Rede_FichaCampoEntradaRow } from './Rede_FichaCampoEntradaRow'
import type { Rede_FichaSocioEntradaRow } from './Rede_FichaSocioEntradaRow'
import { registerContract } from './validate'

export interface Rede_FichaInput {
unidade?: string
campos?: Rede_FichaCampoEntradaRow[]
socios?: Rede_FichaSocioEntradaRow[]
}

registerContract('Rede_FichaInput', {
  unidade: { type: 'string',  required: false },
  campos: {
    type: 'array',
    required: false,
    items: {
      campo: { type: 'string',  required: false },
      valor: { type: 'string',  required: false },
    },
  },
  socios: {
    type: 'array',
    required: false,
    items: {
      nome:       { type: 'string',  required: false },
      cpf:        { type: 'string',  required: false },
      nascimento: { type: 'string',  required: false },
      email:      { type: 'string',  required: false },
    },
  },
})
